<div class="notifications-menu">
  <p-button
    icon="pi pi-bell"
    [rounded]="true"
    variant="text"
    severity="secondary"
    [badge]="unreadCount() ? badgeValue : undefined"
    badgeSeverity="danger"
    [pTooltip]="tooltip"
    tooltipPosition="bottom"
    ariaLabel="Notificaciones"
    (onClick)="panel.toggle($event); onOpen()"
  ></p-button>

  <!-- Sin appendTo="body" a propósito: el panel se ancla dentro del header, que es position: fixed,
       para que quede pegado a la campana. Al colgarlo del body se posicionaba en coordenadas de
       página y se despegaba al hacer scroll. -->
  <p-popover #panel styleClass="notifications-overlay">
    <div class="notifications-panel">
      <div class="notifications-header">
        <strong>Notificaciones</strong>
        @if (notifications().length) {
          <p-button label="Limpiar" icon="pi pi-filter-slash" iconPos="left" size="small" variant="text" severity="secondary" (onClick)="clear()" />
        }
      </div>

      @if (notifications().length) {
        <ul class="notifications-list">
          @for (notification of notifications(); track trackById($index, notification)) {
            <li class="notifications-item" [class.notifications-item--unread]="!notification.read">
              @if (notification.link) {
                <p-button
                  [icon]="notification.icon"
                  iconPos="left"
                  variant="text"
                  severity="secondary"
                  [fluid]="true"
                  styleClass="notifications-item-action"
                  [ariaLabel]="'Abrir notificación: ' + notification.title + '. ' + notification.detail"
                  (onClick)="openNotification(notification)"
                >
                  <span class="notifications-item-body">
                    <span class="notifications-item-title">{{ notification.title }}</span>
                    <span class="notifications-item-detail">{{ notification.detail }}</span>
                    <small class="notifications-item-time">{{ relativeTime(notification.timestamp) }}</small>
                  </span>
                </p-button>
              } @else {
                <div class="notifications-item-static">
                  <i class="notifications-item-icon" [class]="notification.icon" aria-hidden="true"></i>
                  <div class="notifications-item-body">
                    <span class="notifications-item-title">{{ notification.title }}</span>
                    <span class="notifications-item-detail">{{ notification.detail }}</span>
                    <small class="notifications-item-time">{{ relativeTime(notification.timestamp) }}</small>
                  </div>
                </div>
              }
            </li>
          }
        </ul>
      } @else {
        <div class="notifications-empty">
          <i class="pi pi-inbox"></i>
          <span>Sin notificaciones por ahora.</span>
        </div>
      }
    </div>
  </p-popover>
</div>
